import * as React from 'react';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import {
    SingleScoreBox,
    SingleScoreBoxItem,
    SingleScoreItem,
    SingleScoreItemTertiary,
    SingleScoreWrapper,
    SingleScoreWrapperTertiary,
} from 'src/domains/sportsbook/webview/components/events/row/Score.style';
import { observer } from 'src/utils/mobx-react';
import { EventListGroupEventItemType } from 'src_common/common/websocket2/modelsApi/EventsCollectionQuery';

interface ScorePropsType {
    smallEvent: EventListGroupEventItemType;
    dataTest?: string;
}

export const SingleScore = observer('SingleScore', (props: ScorePropsType) => {
    const { smallEvent, dataTest } = props;
    const common = useCommon();
    const configState = ConfigComponents.get(common).config;

    const eventModel = smallEvent.id2.getEventModel();

    if (eventModel === null) {
        return null;
    }

    const { timeSettingsStarted, scoreHome, scoreAway } = eventModel;

    if (timeSettingsStarted === false || scoreHome === null || scoreAway === null) {
        return null;
    }

    if (configState.componentVariants.singleScoreVariant === DefaultComponentVariantType.PRIMARY) {
        return (
            <SingleScoreWrapper data-test={dataTest ?? 'single-score'}>
                <SingleScoreItem>{scoreHome}</SingleScoreItem>
                <SingleScoreItem>{scoreAway}</SingleScoreItem>
            </SingleScoreWrapper>
        );
    }

    if (configState.componentVariants.singleScoreVariant === DefaultComponentVariantType.TERTIARY) {
        return (
            <SingleScoreWrapperTertiary data-test={dataTest ?? 'single-score'}>
                <SingleScoreItemTertiary>{scoreHome}</SingleScoreItemTertiary>
                <SingleScoreItemTertiary>{scoreAway}</SingleScoreItemTertiary>
            </SingleScoreWrapperTertiary>
        );
    }

    return (
        <SingleScoreBox data-test={dataTest ?? 'single-score'}>
            <SingleScoreBoxItem>{scoreHome}</SingleScoreBoxItem>
            <SingleScoreBoxItem>{scoreAway}</SingleScoreBoxItem>
        </SingleScoreBox>
    );
});
